import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './MyPlanLoadingConfig.Styles';

const loadingConfig = theme => [
  {
    left: setLoadingConfigObject('line', 1, 80, styles.status),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.title),
  },
  {
    style: styles.seperator(theme),
  },
  {
    containerStyle: styles.planBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.planBodyItemSquare),
  },
  {
    containerStyle: styles.planBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.planBodyItemSquare),
  },
  {
    containerStyle: styles.planBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.planBodyItemSquare),
  },
  {
    style: styles.seperator(theme),
  },
  {
    style: styles.pricePerMonthContainer,
    left: setLoadingConfigObject('line', 1, 57),
    right: setLoadingConfigObject('line', 1, null, styles.pricePerMonthValue),
  },
];

export { loadingConfig, shimmerPlaceholderConfig };
